import { FormControlContext } from "@/components/ui/FormControl";
import { useContext } from "react";

export function useFormControl() {
  const context = useContext(FormControlContext);

  return context;
}
